import * as creditBillsMiddleware from "middleware/creditBills";
import { getStateByCode, codeStates } from "pages/transactions/constants";
import { types } from "reducers/creditBills";
import { actions as notificationActions } from "reducers/notification";
import { call, put, takeLatest } from "redux-saga/effects";
import { handleError } from "sagas";

const sagas = [
    takeLatest(types.CREDIT_BILLS_REQUEST, getCreditBillsSaga),
    takeLatest(types.CREDIT_BILLS_DETAIL_REQUEST, getCreditBillsDetailSaga),
    takeLatest(types.ACTION_BILL_REQUEST, actionBillSaga),
    takeLatest(types.CREDIT_BENEFICIARY_REQUEST, getBeneficiariesSaga),
];

export default sagas;

function* getCreditBillsSaga({ filters }) {
    try {
        const response = yield call(creditBillsMiddleware.creditBillList, filters);
        const { isFinished, category } = getStateByCode(response.data.code);

        if (isFinished) {
            yield put({
                type: types.CREDIT_BILLS_SUCCESS,
                creditBillList: response.data.data.facturas,
                pageNumber: response.data.data.pageNumber,
                rowsPerPage: response.data.data.rowsPerPage,
                totalPages: response.data.data.totalPages,
                totalFacturas: response.data.data.rowsPerPage,
            });
            return;
        }
        if (category.isWarning || category.isError) {
            const level = category.isWarning ? "warning" : "error";
            yield put({
                type: types.CREDIT_BILLS_FAILURE,
                errorMessage: response.data.message,
            });
            yield put(notificationActions.showNotification(response.data.message, level, ["creditBillsPage"]));
        }
    } catch (error) {
        if (error?.data.code === "BAK001E") {
            const _error = {
                ...error,
                data: {
                    ...error.data,
                    message: "Por favor, intentá más tarde o comunicate con el banco.",
                },
            };
            yield call(handleError, _error);
        } else {
            yield put(notificationActions.showNotification(error.data.message, "error", ["creditBillsPage"]));
        }
        yield put({
            type: types.CREDIT_BILLS_FAILURE,
            errorMessage: error.data.message,
        });
    }
}

function* getCreditBillsDetailSaga({ cuitEmisor, tipoComprobante, numeroComprobante, puntoVenta }) {
    const response = yield call(creditBillsMiddleware.creditBillsDetail, {
        cuitEmisor,
        tipoComprobante,
        numeroComprobante,
        puntoVenta,
    });
    if (response.type === "W") {
        yield put({ type: types.CREDIT_BILLS_DETAIL_FAILURE });
    } else {
        yield put({
            type: types.CREDIT_BILLS_DETAIL_SUCCESS,
            creditBillsDetailList: response.data.data.invoiceDetail,
        });
    }
}

export const getScopeByAction = (action) => {
    if (action === "TRANSMISSION") {
        return { summaryScope: "transmitFCEMSummaryPage", ticketScope: "servicePaymentTransactionPage" };
    }
    if (action === "INFORM-CBU") {
        return { summaryScope: "credit.bills.modify.page", ticketScope: "credit.bills.trasaction" };
    }
    return { summaryScope: "transmitFCEMSummaryPage", ticketScope: "actionFCEMTransactionPage" };
};

function* actionBillSaga({ actionData, formikBag, credentialType }) {
    const { summaryScope, ticketScope } = getScopeByAction(actionData.action);
    const params = { ...actionData, routeParam: actionData.action ? actionData.action.toLowerCase() : "" };

    try {
        const response = yield call(creditBillsMiddleware.fcemAction, params);

        const { isFinished, hasValidationError } = getStateByCode(response.data.code);

        if (hasValidationError) {
            const msj = response.data?.data[credentialType];
            if (msj) {
                yield put(notificationActions.showNotification(msj, "error", [summaryScope]));
                formikBag.setErrors({
                    credential: msj,
                });
                return;
            }

            if (response.data?.data?.message) {
                yield put(notificationActions.showNotification(response.data.data.message, "error", [summaryScope]));
            } else {
                yield put(notificationActions.showNotification(response.data?.message, "error", [summaryScope]));
            }

            return;
        }

        yield put({
            type: types.ACTION_BILL_SUCCESS,
            actionTicket: {
                status: codeStates[response.data.code],
                ...response.data,
            },
        });

        const hasErrorCode = response.data?.data?.responseList.some((item) => item.code === "BAK599E");
        const responseWithError = response.data?.data?.responseList.find((item) => item.code === "BAK599E");

        if (hasErrorCode) {
            yield put(notificationActions.showNotification(responseWithError.message, "error", [ticketScope]));
            return;
        }

        if (isFinished) {
            yield put(notificationActions.showNotification(response.data.message, "success", [ticketScope]));
        }
    } catch (error) {
        let errorMessage = error.data.message;

        if (error.data.code === "COR002E" && error.data.data?.responseList) {
            errorMessage = error.data.data.responseList[0].message;
        }

        yield put(notificationActions.showNotification(errorMessage, "error", [summaryScope]));
        yield put({
            type: types.ACTION_BILL_FAILURE,
            errorMessage,
        });
    } finally {
        formikBag.setSubmitting(false);
    }
}

function* getBeneficiariesSaga({ transmissionType }) {
    try {
        const response = yield call(creditBillsMiddleware.beneficiaryList, { transmissionType });
        const { isFinished } = getStateByCode(response.data.code);

        if (isFinished) {
            yield put({
                type: types.CREDIT_BENEFICIARY_SUCCESS,
                beneficiaries: response.data.data,
            });
        }
    } catch (error) {
        yield put(notificationActions.showNotification(error.data.message, "error", ["transmitFCEMPage"]));
        yield put({
            type: types.CREDIT_BENEFICIARY_FAILURE,
            errorMessage: error.data.message,
        });
    }
}
